export default __webpack_public_path__ + "static/media/evolution.37802eb8.svg";